import { fmtTL } from "../../lib/format";

const MON = ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"];
export const METRICS = { fark: "Fark (Kâr/Zarar)", wilco: "Toplam (WILCO)", taseron: "Toplam (TAŞERON)" };
const th = "px-2 py-2 text-[10px] uppercase tracking-wider font-semibold whitespace-nowrap";
const td = "px-2 py-1.5 text-[11px] font-mono numeric-cell whitespace-nowrap";
const tone = (metric, v) => (metric === "fark" ? (v < 0 ? "text-red-700" : v > 0 ? "text-emerald-700" : "text-slate-400") : v ? "" : "text-slate-400");

// Yıllık görünüm: Proje | Ana Başlık | 12 ay | Yıl Toplamı — hücre değeri seçilen ölçüt (FARK / WILCO / TAŞERON); ay hücresine tıklayınca aylık detay açılır
export function YearlyTable({ data, metric, onCell }) {
  const cell = (node, mo, extra, key) => {
    const v = node.months[mo][metric];
    return (
      <td key={mo} className={`${td} ${tone(metric, v)} ${extra ? "font-bold" : ""} ${onCell ? "cursor-pointer hover:bg-amber-50" : ""}`} data-testid={key ? `${key}-${mo}` : undefined}
        onClick={onCell ? () => onCell(mo, node) : undefined} title={onCell ? `${MON[Number(mo.slice(5)) - 1]} ${mo.slice(0, 4)} — aylık görünümde aç` : undefined}>{v ? fmtTL(v) : "—"}</td>
    );
  };
  const line = (a, b, node, { total = false, key, onCellRow } = {}) => (
    <tr key={key} className={`border-t ${total ? "bg-slate-100 border-slate-300 font-bold" : "border-slate-100"}`} data-testid={key}>
      <td className={`px-2 py-1.5 text-xs font-bold sticky left-0 bg-inherit ${total ? "" : "text-slate-800"}`}>{a}</td>
      <td className={`px-2 py-1.5 text-xs font-semibold uppercase sticky left-[180px] bg-inherit`}>{b}</td>
      {data.months.map((mo) => cell(node, mo, total, onCellRow ? key : null))}
      <td className={`${td} font-extrabold ${tone(metric, node.total[metric])}`}>{fmtTL(node.total[metric])}</td>
    </tr>
  );
  return (
    <div className="bg-white border border-slate-200 rounded-lg overflow-hidden" data-testid="pcsum-yearly">
      <div className="px-4 py-2.5 border-b border-slate-100 text-xs font-bold uppercase tracking-wide text-slate-700">{data.year} — 12 ay · proje × ana başlık · {METRICS[metric]}</div>
      <div className="overflow-x-auto">
        <table className="w-full tbl [&_tbody_tr]:bg-white [&_tfoot_tr]:bg-white">
          <thead className="bg-slate-900 text-white">
            <tr className="bg-slate-900">
              <th className={`${th} text-left sticky left-0 bg-slate-900 min-w-[180px]`}>Proje</th>
              <th className={`${th} text-left sticky left-[180px] bg-slate-900 min-w-[150px]`}>Ana Başlık</th>
              {data.months.map((mo) => <th key={mo} className={`${th} text-right`}>{MON[Number(mo.slice(5)) - 1]}</th>)}
              <th className={`${th} text-right`}>Yıl Toplamı</th>
            </tr>
          </thead>
          <tbody>
            {data.projects.map((p) => (<FragmentProject key={p.id} p={p} line={line} onCell={onCell} />))}
            {data.projects.length === 0 && <tr><td colSpan={15} className="py-8 text-center text-xs text-slate-500">Bu yılda kayıt yok</td></tr>}
          </tbody>
          <tfoot>
            {data.categories.map((c) => line("Tüm Projeler", c.name, c, { key: `pcsum-year-cat-${c.category_id}` }))}
            {line("Tüm Projeler", "Genel Toplam", data.grand, { total: true, key: "pcsum-year-grand" })}
          </tfoot>
        </table>
      </div>
    </div>
  );
}

function FragmentProject({ p, line, onCell }) {
  return (<>
    {p.rows.map((r, i) => line(i === 0 ? p.name : "", r.name, { ...r, project_id: p.id }, { key: `pcsum-year-${p.id}-${r.category_id}`, onCellRow: !!onCell }))}
    {line("", "Toplam", { ...p, project_id: p.id, category_id: null }, { total: true, key: `pcsum-year-total-${p.id}` })}
  </>);
}

// PDF bölümü (seçili ölçüt)
export function yearlyPdfSections(data, metric) {
  if (!data) return [];
  const headers = ["Proje", "Ana Başlık", ...data.months.map((mo) => MON[Number(mo.slice(5)) - 1]), "Yıl Toplamı"];
  const vals = (n) => [...data.months.map((mo) => fmtTL(n.months[mo][metric])), fmtTL(n.total[metric])];
  const rows = [];
  for (const p of data.projects) {
    p.rows.forEach((r, i) => rows.push([i === 0 ? p.name : "", r.name, ...vals(r)]));
    rows.push(["", "TOPLAM", ...vals(p)]);
  }
  return [{
    title: `${data.year} — ${METRICS[metric]} · proje × ana başlık`,
    headers, rows,
    footer: [...data.categories.map((c) => ["TÜM PROJELER", c.name, ...vals(c)]), ["TÜM PROJELER", "GENEL TOPLAM", ...vals(data.grand)]],
    aligns: ["L", "L", ...Array(13).fill("R")],
  }];
}
